import classnames from 'classnames';
import React, { ComponentProps, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import markdownGfm from 'remark-gfm';
// import MemoizedEmbed from './MemoizedEmbed';
import PdfEmbed from './PdfEmbed';
import remarkCenter from './remark-center';

//@ts-expect-error TODO: Remove by upgrading to core-js and correctly polyfilling
import shim from 'string.prototype.matchall/shim';
//@ts-expect-error TODO: Remove by upgrading to core-js and correctly polyfilling
import shim2 from 'string.prototype.replaceall/shim';
import { processMarkdown } from './markdown-processing';
shim();
shim2();

interface Props {
  children: string;
  className?: string;
  prose?: 'default' | 'sm' | 'none';
}

export const CarlitoMarkdownRenderer = ({ children, className, prose = 'default' }: Props) => {
  const processedMarkdown = useMemo(() => {
    return processMarkdown(children);
  }, [children]);

  const markdownComponents = useMemo(() => {
    const components: ComponentProps<typeof ReactMarkdown>['components'] = {
      p: ({ node, ...props }) => {
        return <div {...props} />;
      },
      img: ({ node, ...props }) => {
        const altText = props.alt as string | undefined;
        return (
          <span>
            <img alt="" className="rounded-md" {...props} />
            {altText && (
              <span className="w-full block -mt-6 text-sm opacity-75 text-primary-default text-center">
                {altText}
              </span>
            )}
          </span>
        );
      },
      a: React.memo(
        ({ node, ...props }) => {
          const href = props.href as string | undefined;
          if (href?.endsWith('.pdf')) {
            return <PdfEmbed pdfUrl={href} />;
          }
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          return <a {...props} />;
        },
        (prevProps, nextProps) =>
          nextProps.href === prevProps.href && prevProps.children === nextProps.children
      ),
    };
    return components;
  }, []);

  return (
    <ReactMarkdown
      components={markdownComponents}
      className={classnames(
        prose === 'none'
          ? undefined
          : {
              prose: true,
              'prose-sm': prose === 'sm',
            },
        'max-w-none',
        className
      )}
      remarkPlugins={[markdownGfm, remarkCenter]}
    >
      {processedMarkdown}
    </ReactMarkdown>
  );
};
